import { instanceMixins } from './instanceMixins.js'

export function mixins (Store) {
  instanceMixins(Store)
}
